// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021014/js/" + chunkId + "." + {"44":"7096f5da","225":"fa8a0749","481":"7e1ad9ef","486":"19cb103e","770":"ba07096b"}[chunkId] + ".0.43528324156585496.chunk.js";
};